import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HeaderDepartmentsService {
    private color = new Subject<any>();
    private icon = new Subject<any>();

    sendColor(color: string) {
        this.color.next({headerColor: color});
    }

    sendCartIcon(ico: string) {
      this.icon.next({icon: ico});
    }

    getCartIcon(): Observable<any> {
      return this.icon.asObservable();
    }

    getColor(): Observable<any> {
        return this.color.asObservable();
    }
}
